<template>
  <div>
    <div>
    <div v-for="(value,pos) of data">
      <v-row>
        <v-col>
          <Input
            :name="value.value || ' '"
            :readonly="readonly"
            :value="value"
            :roles="roles"
            name_readonly
            @update="(new_value) => {update_prop(pos,new_value)}"
            @delete="delete_prop(pos)"
          >
            <template v-slot:extra_actions>
              <AddColumn
                v-if="!readonly"
                :bp="bp"
                :field="value"
                @submit="(new_value) => {update_prop(pos,new_value)}"
                custom_icon="mdi-pencil"
              />
            </template>
          </Input>
        </v-col>
      </v-row>
    </div>
    <v-row>
      <v-col>
        <div>
          <AddColumn
            v-if="!readonly"
            :bp="bp"
            @submit="new_prop"
          />
        </div>
      </v-col>
    </v-row>
  </div>
  </div>
</template>
  
<script>
  import Input from '@/components/bpcreator/inputs/Input';
  import AddFormItem from '@/components/bpcreator/model/AddFormItem';
  import AddColumn from '@/components/bpcreator/model/AddColumn';
  export default {
    components: {
      Input,
      AddFormItem,
      AddColumn,
    },
      
    name: 'Columns',
      
    props: {
      bp: {},
      name: {},
      data: {default: () => ([])},
      readonly: Boolean,
      roles: {default: ()=>({})},
    },
      
    data: () => ({
    }),
      
    computed: {
    },
      
    mounted() {
    },
      
    methods: {
      update(value) {
        this.$emit('update',value);
      },

      new_prop(new_prop) {
        let items = this.data.slice();
        items.push(new_prop)
        this.update(items);
      },

      update_prop(pos,value) {
        let items = this.data.slice();
        items[pos] = value;
        this.update(items);
      },

      delete_prop(pos) {
        let new_obj = this.data.slice();
        new_obj.splice(pos,1);
        this.update(new_obj);
      },
    },
  
    watch: {
    },
  }
</script>